import ErrorMessage from "./ErrorMessage";

function ErrorPage() {
    return (
        <ErrorMessage
            titleKey="error.errorPage.title"
            messageKey="error.errorPage.message"
            buttonLabelKey="homeButton"
            buttonTo="/contact"
        />
    );
}

export default ErrorPage;
